<template>
  <div class="workout-editor">
    <template v-if="readOnly">
      <!-- The name is the page title -->
      <p v-if="workout.description" class="text-left description">{{ workout.description }}</p>
    </template>
    <template v-else>
      <b-form-group label="Name" label-size="sm">
        <b-form-input size="sm" :value="workout.name" @input="onNameChange"/>
      </b-form-group>
      <b-form-group label="Description" label-size="sm">
        <b-form-textarea size="sm" rows="2" :value="workout.description" @input="onDescriptionChange"/>
      </b-form-group>
    </template>

    <WorkoutCard :workout="workout" :compact="true" :hide-title="true" class="mb-3"/>

    <WorkoutStepEditor
        v-for="(step, i) in workout.steps"
        :key="i"
        :step="step"
        :read-only="readOnly"
        :is-first="i === 0"
        :is-last="i === workout.steps.length - 1"
        @update="onUpdateStep(i, $event)"
        @remove="onRemoveStep(i)"
        @move-up="onMoveStep(i, -1)"
        @move-down="onMoveStep(i, 1)"
    />

    <div v-if="!readOnly" class="mt-2">
      <b-button size="sm" variant="outline-primary" @click="addStep">+ Add Step</b-button>
      <b-button size="sm" variant="outline-secondary" class="ml-2" @click="addRepeat">+ Add Repeat Block</b-button>
    </div>
  </div>
</template>

<script>
import WorkoutStepEditor from "@/components/Workouts/WorkoutStepEditor";
import WorkoutCard from "@/components/Workouts/WorkoutCard";

export default {
  name: 'WorkoutEditor',
  components: {WorkoutStepEditor, WorkoutCard},
  props: {
    workout: {
      type: Object,
      default: () => ({name: '', description: '', steps: []}),
    },
    // Shows the workout without any editing controls
    readOnly: Boolean,
  },
  methods: {
    emit(changes) {
      this.$emit('change', {...this.workout, ...changes});
    },
    onNameChange(value) {
      this.emit({name: value});
    },
    onDescriptionChange(value) {
      this.emit({description: value});
    },
    onUpdateStep(i, newStep) {
      const steps = this.workout.steps.slice();
      steps.splice(i, 1, newStep);
      this.emit({steps});
    },
    onRemoveStep(i) {
      const steps = this.workout.steps.slice();
      steps.splice(i, 1);
      this.emit({steps});
    },
    onMoveStep(i, direction) {
      const target = i + direction;
      if (target < 0 || target >= this.workout.steps.length) return;
      const steps = this.workout.steps.slice();
      [steps[i], steps[target]] = [steps[target], steps[i]];
      this.emit({steps});
    },
    addStep() {
      const steps = this.workout.steps.concat([{
        type: 'WorkoutStep',
        intensity: 'ACTIVE',
        durationType: 'TIME',
        durationValue: 300,
        zones: [2],
      }]);
      this.emit({steps});
    },
    addRepeat() {
      const steps = this.workout.steps.concat([{
        type: 'WorkoutRepeatStep',
        repeatType: 'REPEAT_UNTIL_STEPS_CMPLT',
        repeatValue: 2,
        steps: [{
          type: 'WorkoutStep',
          intensity: 'ACTIVE',
          durationType: 'TIME',
          durationValue: 60,
          zones: [4],
        }],
      }]);
      this.emit({steps});
    },
  },
}
</script>

<style scoped>
.description {
  white-space: pre-line;
}
</style>
